<template>
  <div class="dashboard">
    <!-- ============================================================ -->
    <!-- 采购端 (caogou) 工作台 -->
    <!-- ============================================================ -->
    <div class="dashboard-main">
      <!-- 顶部横幅 -->
      <el-row :gutter="20" style="margin-top: 2vh;">
        <el-col :span="24">
            <el-card class="banner-card" shadow="never">
            <div class="banner-content">
                <div class="banner-text">
                <h2>👋 欢迎回来，{{ user.name }}</h2>
                <p>采购端数据总览 · 实时掌握采购动态</p>
                </div>
                <div class="banner-actions">
                <el-button plain  @click="goShop">去商城采购</el-button>
                <el-button plain   @click="goOrders" >我的订单</el-button>
                </div>
            </div>
            </el-card>
        </el-col>
        </el-row>

      <!-- 统计卡片行（采购端专用） -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="8">
          <el-card class="stat-card" @click.native="goTo('waitReceive')">
            <div class="stat-num">{{ caogouStats.waitReceive }}</div>
            <div class="stat-label">待收货订单</div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="stat-card" @click.native="goTo('inTransit')">
            <div class="stat-num">{{ caogouStats.inTransit }}</div>
            <div class="stat-label">运输中订单</div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="stat-card" @click.native="goTo('afterSale')">
            <div class="stat-num">{{ caogouStats.afterSale }}</div>
            <div class="stat-label">售后处理中</div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 快捷入口（采购端专用） -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="4" v-for="link in quickLinks" :key="link.title">
          <el-card class="quick-link" @click.native="$router.push(link.path)">
            <div class="quick-content">
              <i :class="link.icon"></i>
              <span>{{ link.title }}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 金额统计（采购端：本月消费总额 & 本月下单笔数） -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="12">
          <el-card class="amount-card">
            <div class="amount-num" style="color: #F56C6C;">￥{{ caogouStats.monthTotal }}</div>
            <div class="amount-label">本月消费总额</div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="amount-card">
            <div class="amount-num" style="color: #67C23A;">{{ caogouStats.monthOrderCount }}</div>
            <div class="amount-label">本月下单笔数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      // 用户信息（从 localStorage 读取）
      user: {
        name: localStorage.getItem('user_name') || '采购员'
      },
      // 采购端统计数据（全部默认为 0）
      caogouStats: {
        waitReceive: 0,
        inTransit: 0,
        afterSale: 0,
        monthTotal: 0,
        monthOrderCount: 0
      },
      // 快捷入口（采购端专用）
      quickLinks: [
        { title: '采购商城', path: '/Shopindex', icon: 'el-icon-shopping-cart-full' },
        { title: '我的订单', path: '/ePower/connection', icon: 'el-icon-s-order' },
        { title: '售后中心', path: '/ePower/ordersh', icon: 'el-icon-service' },
        { title: '收货地址', path: '/ePower/orderdz', icon: 'el-icon-location' },
        { title: '合同档案', path: '/hetong/hetongcgList', icon: 'el-icon-document' }
      ]
    }
  },
  methods: {

    // 跳转方法（可保留原有路由映射）
    goShop () {
      this.$router.push('/Shopindex')
    },
    goOrders () {
      this.$router.push('/ePower/connection')
    },
    goTo (module) {
      const routes = {
        waitReceive: '/ePower/connection',
        inTransit: '/ePower/connection',
        afterSale: '/ePower/ordersh'
      }
      const path = routes[module]
      if (path) {
        this.$router.push(path)
      } else {
        this.$message.info('跳转功能开发中')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  padding: 20px;
  box-sizing: border-box;

  // 横幅
  .banner-card {
    background: linear-gradient(135deg, #28a766, #2dac6a);
    color: #fff;
    border-radius: 12px;
    overflow: hidden;

    .banner-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 24px;

      .banner-text {
        h2 {
          margin: 0;
          font-weight: 500;
        }
        p {
          margin: 6px 0 0;
          opacity: 0.9;
        }
      }
    }
     .banner-actions {
        display: flex;
        gap: 12px; /* 按钮间距 */
        flex-shrink: 0; /* 防止压缩 */
    .el-button {
        border-color: #fff;
        background: rgba(255,255,255,0.1);
        color: #fff;
      border-width: 2px; /* 加粗白边更明显 */
      font-weight: 500;
      &:hover {
         color: #28a766;
         background-color: #fff;

      }
    }
  }
  }

  // 统计卡片
  .stat-card {
    text-align: center;
    cursor: pointer;
    border-radius: 20px;
    transition: all 0.2s;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 4px 12px rgba(64,158,255,0.2);
    }
    .stat-num {
      font-size: 32px;
      font-weight: bold;
      color: #409EFF;
    }
    .stat-label {
      font-size: 14px;
      color: #606266;
      margin-top: 6px;
    }
  }

  // 快捷入口
  .quick-link {
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    }
    .quick-content {
      padding: 12px 0;
      i {
        font-size: 32px;
        color: #409EFF;
        display: block;
        margin-bottom: 6px;
      }
      span {
        font-size: 14px;
        color: #303133;
      }
    }
  }

  // 金额卡片
  .amount-card {
    text-align: center;
    .amount-num {
      font-size: 28px;
      font-weight: bold;
    }
    .amount-label {
      font-size: 14px;
      color: #606266;
      margin-top: 4px;
    }
  }
}
</style>
